import { StoreLoadingEnum } from 'src/store/state/types';

export enum JobStatus {
  NotStarted = 'NotStarted',
  Running = 'Running',
  Succeeded = 'Succeeded',
  SucceededWithIssues = 'SucceededWithIssues',
  Failed = 'Failed',
}

export enum JobPriority {
  Low = 'Low',
  Default = 'Default',
  High = 'High',
}

export interface JobOptions {
  type?: string;
  name?: string;
  status?: JobStatus | JobStatus[];
  take?: number;
  page?: number;
  sort?: string;
  isRefresh?: boolean;
}

export interface TableMetadata {
  loadedPages: Set<number>;
}

export interface Job {
  jobId?: string;
  name?: string | null;
  type?: string | null;
  status?: JobStatus;
  priority?: JobPriority;
  creationDateTime?: string;
  percentComplete?: number;
  tasks?: any[];
  files?: any[];
  expirationDate?: string;
  parameters?: any;
}

export interface CreateJobObj {
  fileType: string;
  fileId: string;
}

export interface CreateJobInput {
  name: string;
  type: string;
  priority?: JobPriority;
  files: CreateJobObj[];
  parameters: any;
}

export interface JobInitialState<DATA, LOADING = StoreLoadingEnum, ERROR = Error | null, JOB_DATA = Job> {
  loading: LOADING;
  error: ERROR;
  data: DATA;
  jobData: JOB_DATA;
}

export interface UpdateExpireDateOptions {
  id: string;
  date: string;
  propertyName: string;
}